export default __webpack_public_path__ + "static/media/abacaxi.4381cbe6.jpg";